const SET_USER = '[Authentication] Set User';
const SET_LOADING = '[Authentication] Set Loading';

export { SET_USER, SET_LOADING };
